export default __webpack_public_path__ + "static/media/_S3A5915_REV.c12fec80.jpg";